/* global __LOCALHOST_ENDPOINT__, __PRODUCTION_ENDPOINT__, __STAGING_ENDPOINT__, __APP_ENV__ */
// client/src/utils/api.js

// Build-time flags (supports BOTH Vite define() and CRA REACT_APP_*)
const LOCAL_EP =
  (typeof __LOCALHOST_ENDPOINT__  !== "undefined" ? __LOCALHOST_ENDPOINT__  : process.env.REACT_APP_LOCALHOST_ENDPOINT)  || "http://localhost:5000";
const PROD_EP  =
  (typeof __PRODUCTION_ENDPOINT__ !== "undefined" ? __PRODUCTION_ENDPOINT__ : process.env.REACT_APP_PRODUCTION_ENDPOINT) || "";
const STAGING_EP =
  (typeof __STAGING_ENDPOINT__    !== "undefined" ? __STAGING_ENDPOINT__    : process.env.REACT_APP_STAGING_ENDPOINT)    || "";
const APP_ENV =
  (typeof __APP_ENV__             !== "undefined" ? __APP_ENV__             : (process.env.REACT_APP_ENV || "")).toLowerCase();

// Pick a base URL by environment.
// - local: localhost:5000 (default)
// - staging: STAGING_ENDPOINT or same-origin
// - production: PRODUCTION_ENDPOINT or same-origin
function pickBase() {
  const origin = (typeof window !== "undefined" ? window.location.origin : "");
  const env = (APP_ENV || "").toLowerCase();

  if (env === "staging") return STAGING_EP || origin || PROD_EP || LOCAL_EP;
  if (env === "production") return PROD_EP || origin || STAGING_EP || LOCAL_EP;
  // default/local
  return LOCAL_EP;
}

let API_BASE_URL = pickBase();

// Optional runtime override (tests, debugging)
export function setApiBase(url) {
  if (url) API_BASE_URL = String(url).replace(/\/+$/, "");
}
export function getApiBase() {
  return API_BASE_URL;
}

// If caller passes a full URL, return as-is. Otherwise resolve against base.
// If base is empty or same-origin, return a relative path (so cookies/etc. work).
export function apiUrl(path = "/") {
  const p = String(path || "/");
  if (/^https?:\/\//i.test(p)) return p;

  const base = API_BASE_URL || (typeof window !== "undefined" ? window.location.origin : "");
  if (!base || (typeof window !== "undefined" && base === window.location.origin)) {
    return p.startsWith("/") ? p : `/${p}`;
  }
  return `${base.replace(/\/+$/, "")}/${p.replace(/^\/+/, "")}`;
}

export async function apiFetch(path, options = {}) {
  const { timeoutMs = 15000, ...rest } = options;

  const headers = { "Content-Type": "application/json", ...(rest.headers || {}) };
  const init = { ...rest, headers };

  if (init.body && typeof init.body !== "string" && headers["Content-Type"] === "application/json") {
    init.body = JSON.stringify(init.body);
  }

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(new DOMException("Timeout", "AbortError")), timeoutMs);
  init.signal = controller.signal;

  try {
    const res = await fetch(apiUrl(path), init);
    clearTimeout(timer);

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`API ${res.status} ${res.statusText}: ${text}`);
    }

    const ct = res.headers.get("content-type") || "";
    return ct.includes("application/json") ? res.json() : res.text();
  } catch (err) {
    clearTimeout(timer);
    throw err;
  }
}

export function wsUrl(path = "/") {
  const u = apiUrl(path);
  if (/^https?:\/\//i.test(u)) return u.replace(/^http/i, "ws");
  if (typeof window !== "undefined") {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    const host = window.location.host;
    const p = u.startsWith("/") ? u : `/${u}`;
    return `${proto}//${host}${p}`;
  }
  return u;
}
